import { createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

const initialState = {
  // Load cart from localStorage to persist it across sessions
  items: JSON.parse(localStorage.getItem('cartItems')) || [],
};

const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    addToCart: (state, action) => {
      // Use a unique ID for each cart item to handle the same product with different options
      const cartItemId = `${action.payload.id}-${JSON.stringify(action.payload.selectedOptions)}`;
      const itemInCart = state.items.find(item => item.cartItemId === cartItemId);

      if (itemInCart) {
        itemInCart.quantity += action.payload.selectedQuantity;
      } else {
        state.items.push({ ...action.payload, quantity: action.payload.selectedQuantity, cartItemId });
      }
      // Persist to localStorage
      localStorage.setItem('cartItems', JSON.stringify(state.items));
    },
    incrementQuantity: (state, action) => {
      const item = state.items.find(item => item.cartItemId === action.payload);
      if (item) {
        item.quantity++;
        localStorage.setItem('cartItems', JSON.stringify(state.items));
      }
    },
    decrementQuantity: (state, action) => {
      const item = state.items.find(item => item.cartItemId === action.payload);
      if (item && item.quantity > 1) {
        item.quantity--;
        localStorage.setItem('cartItems', JSON.stringify(state.items));
      }
    },
    removeItem: (state, action) => {
      const item = state.items.find(item => item.cartItemId === action.payload);
      if (item) {
        toast.info(`${item.name} removed from cart.`);
      }
      state.items = state.items.filter(item => item.cartItemId !== action.payload);
      localStorage.setItem('cartItems', JSON.stringify(state.items));
    },
    clearCart: (state) => {
      state.items = [];
      localStorage.removeItem('cartItems');
    },
  },
});

export const { addToCart, incrementQuantity, decrementQuantity, removeItem, clearCart } = cartSlice.actions
export default cartSlice.reducer;
